import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Emergency Fund',
    type: t.VariableType.triple,
    description: 'Aim to have at least 3 months net income for the unexpected house / car / washing machine breakdowns etc',
    variable: 'Emergency_Fund',
    variable2: 'Emergency_Fund_Bal',
    variable3: 'Emergency_Fund_Amt',
    frequency: 'Emergency_Fund_Freq',
    label: 'Goal',
    label2: 'Balance',
    label3: 'Saving Amount',
    placeholder: '0.00',
    placeholder2: '0.00',
    placeholder3: '0.00',
  },
  {
    name: 'Education Fund',
    type: t.VariableType.triple,
    description: 'How much are you putting aside to help fund future education expenses for you or your children?',
    variable: 'Education_Fund',
    variable2: 'Education_Fund_Bal',
    variable3: 'Education_Fund_Amt',
    frequency: 'Education_Fund_Freq',
    label: 'Goal',
    label2: 'Balance',
    label3: 'Saving Amount',
    placeholder: '0.00',
    placeholder2: '0.00',
    placeholder3: '0.00',
  },
  {
    name: 'Annual Holiday',
    type: t.VariableType.triple,
    description: 'How much have you saved and do you regularly save for your next holiday?',
    variable: 'Annual_Holiday',
    variable2: 'Annual_Holiday_Bal',
    variable3: 'Annual_Holiday_Amt',
    frequency: 'Annual_Holiday_Freq',
    label: 'Goal',
    label2: 'Balance',
    label3: 'Saving Amount',
    placeholder: '0.00',
    placeholder2: '0.00',
    placeholder3: '0.00',
  },
  {
    name: 'Christmas Fund',
    type: t.VariableType.triple,
    description: 'How much have you saved and do you regularly save for you Christmas?',
    variable: 'Christmas_Fund',
    variable2: 'Christmas_Fund_Bal',
    variable3: 'Christmas_Fund_Amt',
    frequency: 'Christmas_Fund_Freq',
    label: 'Goal',
    label2: 'Balance',
    label3: 'Saving Amount',
    placeholder: '0.00',
    placeholder2: '0.00',
    placeholder3: '0.00',
  },
  {
    name: 'Other',
    type: t.VariableType.triple,
    description: 'Let us know of any other goals and how much you put towards that each month',
    variable: 'Save_Other_1_Goal',
    variable2: 'Save_Other_1_Bal',
    variable3: 'Save_Other_1_Amt',
    frequency: 'Save_Other_1_Freq',
    label: 'Goal',
    label2: 'Balance',
    label3: 'Saving Amount',
    placeholder: '0.00',
    placeholder2: '0.00',
    placeholder3: '0.00',
  },
]

const name = 'Savings Goals'
const title = 'Your Savings Goals'
const description = 'Everyone has goals, big or small - doesn\'t matter. Whether it’s a nice new car, a holiday or even just to clear some debit, we\'re all striving for something. Outline any goals you might have below and how much your contributing to same.'
const outro = ''
const link = Routes.step7

const stepDefinition: t.StepDefinition = {
  index: 7,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
